export let CompanySizeScreamingSnake;
(function (CompanySizeScreamingSnake) {
  CompanySizeScreamingSnake["ONE"] = "ONE";
  CompanySizeScreamingSnake["TwoToFive"] = "TWO_TO_FIVE";
  CompanySizeScreamingSnake["SixToTen"] = "SIX_TO_TEN";
  CompanySizeScreamingSnake["ElevenToTwentyFive"] = "ELEVEN_TO_TWENTY_FIVE";
  CompanySizeScreamingSnake["TwentySixToFifty"] = "TWENTY_SIX_TO_FIFTY";
  CompanySizeScreamingSnake["FiftyOneToOneHundred"] = "FIFTY_ONE_TO_ONE_HUNDRED";
  CompanySizeScreamingSnake["OneHundredAndOneToTwoHundred"] = "ONE_HUNDRED_AND_ONE_TO_TWO_HUNDRED";
  CompanySizeScreamingSnake["TwoHundredAndOneToFiveHundred"] = "TWO_HUNDRED_AND_ONE_TO_FIVE_HUNDRED";
  CompanySizeScreamingSnake["FiveHundredAndOneOrMore"] = "FIVE_HUNDRED_AND_ONE_OR_MORE";
})(CompanySizeScreamingSnake || (CompanySizeScreamingSnake = {}));